import { render } from "./index.vue?vue&type=template&id=c78667cc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=c78667cc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c78667cc"
/* hot reload */
if (module.hot) {
  script.__hmrId = "c78667cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c78667cc', script)) {
    api.reload('c78667cc', script)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=c78667cc&scoped=true", () => {
    api.rerender('c78667cc', render)
  })

}

script.__file = "src/views/static/participate/index.vue"

export default script